export default __webpack_public_path__ + "static/media/sample_6_thumb.cbb9b3f4.png";